import React from 'react';
import BaseModalComponent, {
  StyledBaseModalContent,
} from './BaseModal.component';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { StyledCard } from '../Card.component';
import LogoBlueIcon from '../Icons/Logo/LogoBlue.icon';
import ButtonComponent, { StyledButton } from '../Button.component';
import {
  isDefaultNotification,
  requestNotificationPermission,
} from '../../services/notification.service';
import { setUpFCM } from '../../services/fcm.service';
import { useModalManager } from '../../hooks/ModalManager.hook';
import { useToast } from '../../hooks/useToast';
import { useAppDispatch } from '../../hooks/useAppDispatcher.hook';
import { setUserConfigurationFCMTokenThunk } from '../../redux/User/Configuration/UserConfigurationThunk';

const StyledTurnOnNotificationBody = styled.div`
  width: 300px;
  padding: 40px 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  justify-content: center;
`;
const StyledTurnOnNotificationBtns = styled.div`
  display: flex;
  gap: 15px;

  ${StyledButton} {
    width: 120px;
  }
`;
const StyledTurnOnNotificationDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 15px;
  color: ${({ theme }) => theme.colors.LABEL};
  font-weight: 500;
`;
const StyledTurnOnNotificationTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
  text-align: center;
`;
const StyledNoAccessHeaderTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
`;
const StyledNoAccessHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
const StyledTurnOnNotification = styled.div`
  ${StyledCard} > ${StyledBaseModalContent} {
    margin-top: -25px;
  }
`;

const LOGO_ICON_SIZE = 32;

const TurnOnNotificationComponent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { closeModal } = useModalManager();
  const { successToast, errorToast } = useToast();

  const handleTurnOn = () => {
    const isDefault = isDefaultNotification();
    requestNotificationPermission()
      .then(() => {
        isDefault && closeModal();
        setUpFCM()
          .then(token => {
            dispatch(setUserConfigurationFCMTokenThunk(token));
            successToast(t('notifications.toast.enabled'));
          })
          .catch(err => {
            console.log(err);
            errorToast(t('notifications.toast.error_enabling'));
          });
      })
      .catch(err => {
        isDefault && closeModal();
        console.log(err);
        errorToast(t('notifications.toast.error_enabling'));
      });
  };

  return (
    <StyledTurnOnNotification>
      <BaseModalComponent>
        <StyledNoAccessHeader>
          <LogoBlueIcon width={LOGO_ICON_SIZE} height={LOGO_ICON_SIZE} />
          <StyledNoAccessHeaderTitle>Hunter</StyledNoAccessHeaderTitle>
        </StyledNoAccessHeader>
        <StyledTurnOnNotificationBody>
          <StyledTurnOnNotificationTitle>
            {t('notifications.modal.Turn on Notifications')}
          </StyledTurnOnNotificationTitle>
          <StyledTurnOnNotificationDescription>
            <div>
              {t(
                'notifications.modal.Get notifications when you have new events or important dates you may have missed.',
              )}
            </div>
          </StyledTurnOnNotificationDescription>
          <StyledTurnOnNotificationBtns>
            <ButtonComponent
              appearance="primary"
              handleClick={() => handleTurnOn()}
            >
              {t('Turn on')}
            </ButtonComponent>
            <ButtonComponent handleClick={() => closeModal()}>
              {t('Not now')}
            </ButtonComponent>
          </StyledTurnOnNotificationBtns>
        </StyledTurnOnNotificationBody>
      </BaseModalComponent>
    </StyledTurnOnNotification>
  );
};

export default TurnOnNotificationComponent;
